import { MortgageProduct } from '@/constants';
import { MortgageTypeIrt } from '@shared/constants';

const { annuities, linear, interestFree, equity, sustainable, save, savingsGrowth, start, growthWith, credit, other } = MortgageTypeIrt;

export const MORTGAGE_PRODUCT_KEYS = [MortgageProduct.budget, MortgageProduct.house];
export const EXTENDED_MORTGAGE_TYPES_KEYS = [annuities, linear, interestFree, equity, sustainable, save, savingsGrowth, start, growthWith, credit, other];
